import { AddressDetails } from '../onboarding/applicant-address.model';

export interface ApplicantName {
	name: string;
	firstSurname: string;
	secondSurname: string;
}

export enum ApplicantType {
	MEMBER = 1,
	LEAD,
	UNREGISTERED_LEAD,
}

export interface PreApplicationState {
	productCobisId: string;
	periodicityId: number;
	preApplicationId: number;
	folio: string;
	amount: number;
	rate: number;
	subProductId: number;
	creditTerm: number;
	periodPayment: number;
	applicantType: ApplicantType;
	applicantId: number;
	applicantName: ApplicantName;
	applicantPhone: string;
	applicantBirthDate: string;
	isApplicantAMember: boolean;
	isCreditApproved: boolean;
	authorizedAmount: number;
	applicantAmountSelected: number;
	cat: number;
	email: string;
	otpCode: string;
	applicationId: number;
	totalAmountToPay: number;
	productId: number;
	productName: string;
	segmentId: number;
	isSocialContributionApplicable: boolean;
	schoolarshipCertificateId: number;
	curp: string;
	tdcApplicationId: number;
	applicantAddresses: Array<AddressDetails>;
	applicationStatus: number;
	applicationSubStatus: number;
	preApplicationStatus: number;
}

export interface ApplicantData {
	applicantName: ApplicantName;
	applicantType: ApplicantType;
	applicantId: number;
	applicantPhone: string;
	applicantBirthDate: string;
	isApplicantAMember: boolean;
	email: string;
	curp: string;
}

export interface PreApplicationCreditData {
	authorizedAmount: number;
	folio: string;
	rate: number;
	isCreditApproved: boolean;
	creditTerm: number;
}

export interface ApplicantRecipient {
	name: string;
	firstSurname: string;
	secondSurname: string;
	birthDay: string;
}

export interface SimulatorData {
	subProductId: number;
	creditTerm: number;
	amount: number;
	rate: number;
	periodPayment: number;
	periodicityId: number;
	cat: number;
}

export interface CreditSummary {
	creditTerm: number;
	authorizedAmount: number;
	rate: number;
	periodPayment: number;
	subProductId: number;
	cat: number;
	applicantAmountSelected: number;
	isSocialContributionApplicable: boolean;
	preApplicationId: number;
}

export interface CreditParameters {
	periodicityId: number;
	amount: number;
	creditTerm: number;
	subProductId: number;
	segmentId: number;
	productId: number;
	productCobisId: string;
}

export interface ApplicantDataAndPreApplicationId extends ApplicantData {
	preApplicationId: number;
}

export interface AuthorizedCreditDetails {
	perdiodPayment: number;
	cat: number;
	applicantAmountSelected: number;
	totalAmountToPay: number;
}

export interface Product {
	productId: number;
	productName: string;
	subProductId: number;
	segmentId: number;
}
